exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-component='change-pass'] .content {\n  transform-origin: top;\n}\n[data-component='change-pass'] .steps-container {\n  width: 100%;\n  position: relative;\n  margin: 0 0 40px;\n  perspective: 600px;\n}\n[data-component='change-pass'] .step {\n  top: 0;\n  left: 150%;\n  position: absolute;\n  width: 100%;\n}\n[data-component='change-pass'] [data-component='step-buttons'] .btn {\n  width: 200px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/change-pass/change-pass.component.styl
// module id = ../../../../../src/app/master/change-pass/change-pass.component.styl
// module chunks = main